if (!customElements.get('klaviyo-bis')) {
  class KlaviyoBis extends HTMLElement {
    constructor() {
      super();
      this.bis = this.querySelector('.klaviyo-bis-trigger')
      this.actualVariant = null
    }

    connectedCallback() {
      document.addEventListener('variant:change', (e) => this.toggleBis(e));
      this.bis.addEventListener('click', () => this.synchroVariantInPopup());
    }

    synchroVariantInPopup() {
      setTimeout(() => {
        const klaviyoIframe = document.querySelector('#klaviyo-bis-iframe')
        const select = klaviyoIframe?.contentDocument.querySelector(`#klaviyo-bis-modal select`)
        if (select) {
          let indexToSelect = null

          Array.from(select.children).forEach((element, index) => {
            if(Number(element.value) == Number(this.actualVariant)) indexToSelect = index
          });

          if (indexToSelect != null) select.selectedIndex = indexToSelect
        }
      }, 100);
    }

    toggleBis(e) {
      if(!e.target.contains(this)) return

      this.actualVariant = e.detail.variant.id

      if (e.detail.variant.available) this.style.display = 'none'
      if (!e.detail.variant.available) this.style.display = 'block'

      this.bis.style.display = 'inherit'
    }
  }

  customElements.define('klaviyo-bis', KlaviyoBis);
}
